import { DateRangeField } from '@shared/data/entity/fields/DateRangeField';
import { AddressField } from './AddressField';
import { CombinedTagsField } from './CombinedTagsField';
import { DateField } from './DateField';
import { EmailField } from './EmailField';
import { EntityBatchField } from './EntityBatchField';
import { FileField } from './FileField';
import { GenericUntypedJsonBlobField } from './GenericUntypedJsonBlobField';
import { GeolocationField } from './GeolocationField';
import { NumberField } from './NumberField';
import { PersonField } from './PersonField';
import { RelatedEntityField } from './RelatedEntityField';
import { ScheduledAutomationField } from './ScheduledAutomationField';
import { SignatureField } from './SignatureField';
import { SubformField } from './SubformField';
import { TagField } from './TagField';
import { TextField } from './TextField';
import { TimeTrackerField } from './TimeTrackerField';
import { TodoField } from './TodoField';
import { UrlField } from './UrlField';

export interface EditableField {
  isEqual(field: Field): boolean;
  validate(): string | null;
  toFieldJson(): any;
  isEmpty: boolean;
}

export type Field =
  | AddressField
  | CombinedTagsField
  | DateField
  | DateRangeField
  | EmailField
  | EntityBatchField
  | FileField
  | GenericUntypedJsonBlobField
  | GeolocationField
  | NumberField
  | PersonField
  | RelatedEntityField
  | ScheduledAutomationField
  | SignatureField
  | SubformField
  | TagField
  | TextField
  | TimeTrackerField
  | TodoField
  | UrlField;

// helper function to cast a field to a specific type, or null if it's not that type
export function castField<T>(field: any, fieldClass: new (...args: any[]) => T): T | null {
  return field instanceof fieldClass ? field : null;
}
